import { Injectable        } from '@angular/core';
import { NotifierManager   } from '../managers/notifier/notifier.manager';
import { Notifier          } from '../enums/notifier/notifier.enum';
import { NotifierMessage   } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})

export class LogoutError 
{
    constructor(private _notifier : NotifierManager) {}

    generic () 
    {
      this._notifier.show( Notifier.ERROR, NotifierMessage.LOGOUT_GENERIC)
    }

    userNotAllowed()
    {
      this._notifier.show( Notifier.ERROR, NotifierMessage.LOGOUT_USER_NOT_ALLOWED)
    }
}